module.exports = __webpack_public_path__ + "static/img/registration-fee.7130ffcb.png";